import { memo } from 'react';

import { TaxReturnInitializer } from '@dec/shared';
import {
  useGetFormConnection,
  useGetGlobalTaxReturnValues
} from 'app/modules/FormDefinition/services/signalr.hooks';

import { type TaxReturnRequest } from '../../models/types';

export const Initializer = memo(({ readOnly }: { readOnly: boolean }) => {
  const connection = useGetFormConnection();
  const runtime = useGetGlobalTaxReturnValues();

  return (
    <TaxReturnInitializer<TaxReturnRequest>
      readOnly={readOnly}
      connection={connection}
      runtime={runtime}
    />
  );
});
